<section id="content" class="supply-view" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.supplyers }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id">{{lang.supplyersView }}</a>
          </li>
          <li>
            <span *ngIf="single_data">{{ single_data.code }} / {{ single_data.bussines_name }}</span>
          </li>

        </ul>

        <div style="float: right;">
          <div class="social-icons">
       
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">
                    <div class="wrap-reset">

                      <form [formGroup]="generalsForm" class="form-validation">

                        <div class="row">

                          <div class="form-group col-sm-2">

                            <img [src]="image1" width="50%;" height="10%;" (click)="triggerUpload($event.target.files)" />

                             <button (click)="onUpload()" class="btn btn-success"
                              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">Upload</button> 

                          </div>

                          <div class="form-group col-sm-4">
                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="code">{{ lang.code }}</label>
                              </div>
                              <div class="col-sm-9">
                                {{ single_data.code }}
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="bussines_name">{{ lang.businessName }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="bussines_name" readonly> -->
                                {{ single_data.bussines_name }}
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="address">{{ lang.address }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="address" readonly> -->
                                {{ single_data.address }}
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="zipCode">{{ lang.zipCode }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="zip_code" readonly> -->
                                {{ single_data.zip_code }}
                              </div>
                            </div>


                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="city">{{ lang.city }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="city" readonly> -->
                                {{ single_data.city }}
                              </div>
                            </div>


                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="province">{{ lang.province }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="province" readonly> -->
                                {{ single_data.province }}
                              </div>
                            </div>
                            </div>

                            <div class="form-group col-sm-4">

                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="taxCode">{{ lang.taxCode }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="tax_code" readonly> -->
                                {{ single_data.tax_code }}
                              </div>
                            </div>


                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="fiscalCode">{{ lang.fiscalCode }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="fiscal_code" readonly> -->
                                {{ single_data.fiscal_code }}
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="phone">{{ lang.phone }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="phone" readonly>
                                 -->
                                {{ single_data.phone }}
                              </div>
                            </div>


                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="email">{{ lang.email }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="email" readonly> -->
                                <!-- {{ single_data.email | stringbreak }} -->
                                <div *ngFor="let emailval of single_data.email?.split(',')">
                                  {{ emailval }}
                                </div>
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="website">{{ lang.website }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="website" readonly> -->
                                {{ single_data.website }}
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="macroSector">{{ lang.macroSector }}</label>
                              </div>
                              <div class="col-sm-9">
                                <!-- <input type="text" class="form-control" formControlName="macro_sector" readonly>
                                 -->
                                {{ single_data.macro_sector }}
                              </div>
                            </div>
<!-- 
                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="attachments">{{ lang.attachments }}</label>
                              </div>
                              <div class="col-sm-9">
                                <div *ngFor="let sattach of single_data.attachments?.split(',')">
                                  <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/customers/{{sattach}}"
                                    target="_blank">{{ sattach }}</a>
                                </div>
                              </div>
                            </div> -->


                          </div>
                       

                        </div>

                      </form>
                    </div>
                  </div>


                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <!-- <li role="presentation" [ngClass]="{ 'active':generalTab==='activeTab'}"><a href="#generalTab"
                      aria-controls="feedTab" role="tab" data-toggle="tab">{{ lang.generalData }}</a></li> -->

                  <li role="presentation" class="active"><a href="#operating"
                      aria-controls="operating" role="tab" data-toggle="tab">{{
                      lang.operatingLocations }}</a></li>




                </ul>

                <div class="tab-content">

                <div role="tabpanel" class="tab-pane active" id="operating">

                  <div class="row p-10">
                    <div class="col-sm-1">

                      <div class="social-icons">

                        <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                          data-options="splash-2 splash-ef-4">
                          <span class="glyphicon glyphicon-export"></span>
                        </a>


                        <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id=""
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                          <span class="glyphicon glyphicon-file"></span>
                        </a>

                        <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()"
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                          <span class="glyphicon glyphicon-trash"></span>
                        </a>

                      </div>

                    </div>

                    <div class="col-sm-1">
                      <div class="social-icons">
                          <button class="btn btn-success"  (click)="add_operating(this.id)"
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">Add O.L</button>
                      </div>
                    </div>

                    <div  class="col-sm-10">
                      <input
                      style="float: right;width: 20%;"
                      #search
                      id="search"
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      aria-label="Search"
                      aria-describedby="basic-addon1"
                    />                        
                    </div>                       
                  </div>

                  <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                    <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                      id="table1" *ngIf="optloc_data">
                      <thead>
                        <tr>
                          <th>Hidden.No</th>
                          <th>
                            <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                              <input type="checkbox"><i></i>
                            </label>
                          </th>
                          <th>No.</th>
                          <th>{{ ollang?.address }}</th>
                          <th>{{ ollang?.zipCode }}</th>
                          <th>{{ ollang?.city }}</th>
                          <th>{{ ollang?.province }}</th>
                          <th>{{ ollang?.phone }}</th>
                          <th>{{ ollang?.email }}</th>
                          <th>{{ ollang?.notes }}</th>
                          <th>{{ ollang?.action }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let record of optloc_data let i = index" id="{{record.operating_loctionids}}">
                          <td>{{i+1}}</td>
                          <td></td>
                          <td>{{i+1}}</td>
                          <td>{{record.ol_address}}</td>
                          <td>{{record.zip_code}}</td>
                          <td>{{record.city }}</td>
                          <td>{{record.province }}</td>
                          <td>{{record.phone }}</td>
                          <td>{{record.e_mail }}</td>
                          <td>{{record.notes }}</td>
                          <td>
                            <div class="btn-group dropup">

                              <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                              <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                    class="delete_action" (click)="delete_operating(record.operating_loctionids)"><i
                                      class="fa fa-trash"></i> {{ ollang.erase }}</a></li>
                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                    class="edit_action"
                                    (click)="edit_operating(record.operating_loctionids,record.customer_id)"><i
                                      class="fa fa-edit"></i> {{ ollang.modify }}</a></li>
                              </ul>
                            </div>
                          </td>

                        </tr>
                      </tbody>

                    </table>
                  </div>

                </div>

                <div role="tabpanel" class="tab-pane" id="employee">

                  <div class="row p-10">
                    <div class="col-sm-9">

                      <div class="social-icons">



                        <a class="plus-export" data-toggle="modal" data-target="#datatableExport2"
                          data-options="splash-2 splash-ef-4">
                          <span class="glyphicon glyphicon-export"></span>
                        </a>


                        <a class="plus-import" data-toggle="modal" data-target="#datatableImport2" data-action="show"
                          data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                          <span class="glyphicon glyphicon-import"></span>
                        </a>

                        <a class="plus-copy" (click)="multiDuplicateEmp()" data-action="show" data-id=""
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                          <span class="glyphicon glyphicon-file"></span>
                        </a>

                        <a class="plus-delete" *ngIf="deleteOption" (click)="multiDeleteEmp()"
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                          <span class="glyphicon glyphicon-trash"></span>
                        </a>

                      </div>

                    </div>

                    <div class="col-sm-3" style="float: right;">
                      <div class="social-icons">
                        <a class="plus-add" (click)="add_employee(this.id)"
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                          <button class="btn btn-success"><i class="fa fa-plus"></i>Add Employee</button>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                    <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover"
                      id="table2" *ngIf="get_employee">
                      <thead>
                        <tr>
                          <th>Hidden.No</th>
                          <th>
                            <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                              <input type="checkbox"><i></i>
                            </label>
                          </th>
                          <th>No.</th>
                          <th>{{ emplang?.name }}</th>
                          <th>{{ emplang?.surname }}</th>
                          <th>{{ emplang?.email }}</th>
                          <th>{{ emplang?.phone }}</th>
                          <th>{{ emplang?.dob }}</th>
                          <th>{{ emplang?.pob }}</th>
                          <th>{{ emplang?.fiscalCode }}</th>
                          <th>{{ emplang?.qualification }}</th>
                          <th>{{ emplang?.business }}</th>
                          <th>{{ emplang?.action }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let recordemp of get_employee let i = index"
                          id="{{recordemp.customer_employeeId}}">
                          <td>{{i+1}}</td>
                          <td></td>
                          <td>{{i+1}}</td>
                          <td>{{recordemp.name}}</td>
                          <td>{{recordemp.surname}}</td>
                          <td>{{recordemp.email }}</td>
                          <td>{{recordemp.phone }}</td>
                          <td>{{recordemp.dateofbirth }}</td>
                          <td>{{recordemp.placeofbirth }}</td>
                          <td>{{recordemp.fiscal_code }}</td>
                          <td>{{recordemp.qualification }}</td>
                          <td>{{recordemp.business_function }}</td>
                          <td>
                            <div class="btn-group dropup">

                              <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                              <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                    class="delete_action" (click)="delete_employee(recordemp.customer_employeeId)"><i
                                      class="fa fa-trash"></i> {{ emplang.erase }}</a></li>
                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                    class="edit_action"
                                    (click)="edit_employee(recordemp.customer_employeeId,recordemp.customer_id)"><i
                                      class="fa fa-edit"></i> {{ emplang.modify }}</a></li>
                              </ul>
                            </div>
                          </td>

                        </tr>
                      </tbody>

                    </table>
                  </div>

                </div>

                <div role="tabpanel" class="tab-pane" id="consultancy">

                  <div class="row p-10">
                    <div class="col-sm-9">

                      <div class="social-icons">


                        <a class="plus-export" data-toggle="modal" data-target="#datatableExport3"
                          data-options="splash-2 splash-ef-4">
                          <span class="glyphicon glyphicon-export"></span>
                        </a> -


                      </div>

                    </div>

                  </div>

                  <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                    <table datatable [dtOptions]="datatableOptions3" class="table-striped table-sm row-border hover"
                      id="table3" *ngIf="constant_data">
                      <thead>
                        <tr>
                          <!-- <th style="display: none;" class="hidden">Hidden.No</th>
                          <th style="display: none;">
                            <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                              <input type="checkbox"><i></i>
                            </label>
                          </th> -->
                          <th>No.</th>
                          <th>{{ clang?.code }}</th>
                          <th>{{ clang?.typeofContract }}</th>
                          <th>{{ clang?.meetingperYear }}</th>
                          <th>{{ clang?.startingDate }}</th>
                          <th>{{ clang?.contract }}</th>
                          <th>{{ clang?.amount }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let cdrecord of constant_data let i = index" id="{{cdrecord.consultancyId}}">
                          <!-- <td style="display: none;" class="hidden">{{ i + 1 }}</td>
                          <td style="display: none;"></td> -->
                          <td>{{ i + 1 }}</td>
                          <td><a [routerLink]="['/'+AppFrontRoutes.CONSULTANCY_VIEW+'/'+cdrecord.consultancy_code]">{{
                              cdrecord.consultancy_code }}</a></td>
                          <td>{{ cdrecord.contract_type }}</td>
                          <td>{{ cdrecord.starting_date }}</td>
                          <td>{{ cdrecord.meeting_year }}</td>
                          <td><a href="{{ cdrecord.contract_file }}">{{ cdrecord.contract_file }}</a></td>
                          <td>{{ cdrecord.amount }}</td>
                        </tr>
                      </tbody>

                    </table>
                  </div>

                </div>

                <div role="tabpanel" class="tab-pane" id="academy">

                  <div class="row p-10">
                    <div class="col-sm-9">

                      <div class="social-icons">


                        <a class="plus-export" data-toggle="modal" data-target="#datatableExport4"
                          data-options="splash-2 splash-ef-4">
                          <span class="glyphicon glyphicon-export"></span>
                        </a> -


                      </div>

                    </div>

                  </div>

                  <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                    <table datatable [dtOptions]="datatableOptions4" class="table-striped table-sm row-border hover"
                      id="table4" *ngIf="scheduled_info">
                      <thead>
                        <tr>
                          <th>Hidden.No</th>
                          <th>
                            <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                              <input type="checkbox"><i></i>
                            </label>
                          </th>
                          <th>No.</th>
                          <th>{{ alang?.courseCode }}</th>
                          <th>{{ alang?.catCode }}</th>
                          <th>{{ alang?.courseName }}</th>
                          <th>{{ alang?.courseCategory }}</th>
                          <th>{{ alang?.durationHours }}</th>
                          <th>{{ alang?.startDate }}</th>
                          <th>{{ alang?.endDate }}</th>
                          <th>{{ alang?.teacher }}</th>
                          <th>{{ alang?.status }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let sirecord of scheduled_info let i = index" id="{{sirecord.consultancyId}}">
                          <td>{{ i + 1 }}</td>
                          <td></td>
                          <td>{{ i + 1 }}</td>
                          <td>{{ sirecord.sc_couse_code }}</td>
                          <td>{{ sirecord.cat_code }}</td>
                          <td>{{ sirecord.cat_course_name }}</td>
                          <td>{{ sirecord.cat_course_catg }}</td>
                          <td>{{ sirecord.duration }}</td>
                          <td>{{ sirecord.start_date }}</td>
                          <td>{{ sirecord.end_date }}</td>
                          <td>{{ sirecord.main_teacher }}</td>
                          <td>{{ sirecord.sc_sched_status }}</td>
                        </tr>
                      </tbody>

                    </table>
                  </div>

                </div>

                <div role="tabpanel" class="tab-pane" id="project">
                  <div class="row p-10">
                    <div class="col-sm-9">
                      <div class="social-icons">
                        <a class="plus-export" data-toggle="modal" data-target="#datatableExport5"
                          data-options="splash-2 splash-ef-4">
                          <span class="glyphicon glyphicon-export"></span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                    <table datatable [dtOptions]="datatableOptions5" class="table-striped table-sm row-border hover"
                      id="table5" *ngIf="get_project">
                      <thead>
                        <tr>
                          <th>Hidden.No</th>
                          <th>
                            <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                              <input type="checkbox"><i></i>
                            </label>
                          </th>
                          <th>No.</th>
                          <th>{{ plang?.projectCode }}</th>
                          <th>{{ plang?.projectTitle }}</th>
                          <th>{{ plang?.customer }}</th>
                          <th>{{ plang?.responsible }}</th>
                          <th>{{ plang?.startingDate }}</th>
                          <th>{{ plang?.expectedDeliveryDate }}</th>
                          <th>{{ plang?.expectedHour }}</th>
                          <th>{{ plang?.closingDate }}</th>
                          <th>{{ plang?.completion }}</th>
                          <th>{{ plang?.status }}</th>
                          <th>{{ plang?.paymentReference }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let precord of get_project let j = index" id="{{ precord.cid }}">
                          <td>{{ j + 1 }}</td>
                          <td></td>
                          <td>{{ j + 1 }}</td>
                          <td><a
                              href="http://vmi313621.contaboserver.net/Software_backend/project/view/{{ precord.cid }}">{{
                              precord.course_code }}</a></td>
                          <td>{{ precord.title }}</td>
                          <td>{{ precord.customer_id }}</td>
                          <td>{{ precord.emp_id }}</td>
                          <td>{{ precord.start_date }}</td>
                          <td>{{ precord.div_date }}</td>
                          <td>{{ precord.hours }}</td>
                          <td>{{ precord.end_date }}</td>
                          <td>{{ precord.total_per }}</td>
                          <td>
                            <div [innerHTML]="precord.pro_new_lang_data"></div>
                          </td>
                          <td style="width: 30%;">
                            <select class="form-control" name="payment_reference"
                              (change)="change_col($event.target.value,precord.cid)" [value]='precord.payment_ref'>
                              <option value="1" style="background: #FFFF00">Not Invoiced</option>
                              <option value="2" style="background: #FF0000">Invoiced and Not Paid</option>
                              <option value="3" style="background: #D5F5E3">Invoiced and Paid</option>
                            </select>
                          </td>
                        </tr>
                      </tbody>

                    </table>
                  </div>

                </div>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ ollang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ ollang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ ollang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ ollang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ emplang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ emplang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ emplang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
      
        </div>
         -->
      <div class="modal-header">
        <h4 class="modal-title pull-left">Import Employee Data</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>

            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a
                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_customers_employees.csv">Click
                  Here</a> {{ emplang?.todownloadtocsv}}</font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button type="button" class="btn btn-primary" (click)="onclick(this.id)">{{ emplang?.submit }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ clang?.export }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <!-- <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
                (change)="export3_select_deselect_all($event)"><i></i> {{ clang?.selectAll }} </label> -->
        </div>
        <div class="row flexs">

          <div class="active-left">
            <!-- <h2>{{ clang?.activeColumns }}</h2> -->

            <!-- <div class="row" *ngFor="let option of datatableCols3">
                <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                  <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                    (change)="export3_select_deselect($event)"><i></i> {{option.value}}
                </label>
              </div> -->
            <div id="datatableExportBtn3" class="export_dynamic_btn">


            </div>

          </div>

        </div>

        <div class="modal-footer">
          <div class="export_dynamic_btn">
          </div>
          <button class="btn btn-warning" data-dismiss="modal">{{ alang?.close }}</button>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ alang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> {{ alang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export4_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ alang?.close }}</button>
      </div>

    </div>
  </div>
</div>



<div class="modal splash fade" id="datatableExport5" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ plang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export5_select_deselect_all($event)"><i></i> {{ plang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols5">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export5_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn5" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ plang?.close }}</button>
      </div>

    </div>
  </div>
</div>